module.exports = __webpack_public_path__ + "img/weal_3.678431b0.jpg";